<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="search">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item  label="">
              <el-input  v-model="formInline.realname" placeholder="请输入助教姓名" class="select_input"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input  v-model="formInline.phone" placeholder="请输入手机号" class="select_input"></el-input>
            </el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
            <el-button type="primary" @click="batchDelete">批量删除</el-button>
            <el-button type="primary" class="addBtn" @click="addAssistant" v-if="rid != 1">添加</el-button>
          </el-form>
        </div>
        <div class="table">
          <el-table
            ref="multipleTable"
            border
            :data="tableData"
            @selection-change="handleSelectionChange"
            min-height="350px"
            :header-cell-style="{background:'#f5f7fa',color:'#606266'}"
            style="width: 100%">
            <el-table-column
                type="selection"
                fixed
                width="30">
            </el-table-column>
            <el-table-column
              label="姓名"
              >
              <template slot-scope="scope"> 
                <span >{{scope.row.realname}}({{scope.row.sex}})</span>
              </template> 
            </el-table-column>
            <el-table-column
              label="手机号"
             >
              <template slot-scope="scope">{{ scope.row.phone }}</template>
            </el-table-column>
            <el-table-column
              label="用户名"
             >
              <template slot-scope="scope">{{ scope.row.username }}</template>
            </el-table-column>
            <el-table-column
              label="身份证号"
             >
              <template slot-scope="scope">{{scope.row.idcard}}</template>
            </el-table-column>
            <el-table-column
              label="地址"
             >
              <template slot-scope="scope">{{ scope.row.region }}{{ scope.row.address }}</template>
            </el-table-column>
            <el-table-column
              label="创建时间"
             >
              <template slot-scope="scope">{{ scope.row.create_time }}</template>
            </el-table-column>
            <el-table-column
              width='115'
              label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary" plain
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_pagination">
          <el-pagination
            background
            @prev-click="prevClick"
            @next-click="nextClick"
            @current-change="currentClick"
            layout="prev, pager, next"
            :total="total"
            :page-size="page_size"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialog"
      :close-on-click-modal="false"
      width="30%"
      center>
      <span>您是否确定删除所选助教？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { total,page, page_size} from '../../config'
// @ is an alias to /src
export default {
  name: 'Assistant',
  components: {
  },
  data(){
    return {
      tableData: [],
      formInline: {
        realname:'',
        phone:''
      },
      total,
      page,
      page_size,
      centerDialog: false,
      deleteList: [],
      rid:0,
    }
  },
  created(){
    this.rid  = Number(this.$store.state.rid)
  },
  mounted(){
    this.onSubmit()
  },
  methods:{
    
    getinfor(params){
      this.$api.user.assistantList(params)
        .then(res=>{
          if(res.code === 0){
            this.tableData = res.result.result
            this.total = res.result.total
          }else if(res.code === 1010){
            this.tableData = []
            this.total = 0
          }
        }) 
    },
    handleEdit(index,row) {
      this.$router.push({
        path:'/assistant/editAssistant/' + row.id
      })
    },
    handleSelectionChange(value){
      let arr = value
      this.deleteList = []
      for(let i = 0;i < arr.length ; i++){
          this.deleteList.push(arr[i].id)
      }
    },
    handleDelete(index,row) {
      this.deleteList = []
      this.deleteList.push(row.id)
      this.centerDialog = true
    },
    onSubmit() {
      let params = {
        realname:this.formInline.realname,
        phone:this.formInline.phone,
        page:this.page,
        page_size:this.page_size
      }
      this.getinfor(params)
    },
    onReset(){
      if(this.formInline.realname || this.formInline.phone ){
        this.formInline.realname = ''
        this.formInline.phone = ''
        this.onSubmit()
      }
    },
    addAssistant(){
      this.$router.push({
        path:'/assistant/addAssistant'
      })
    },
    batchDelete(){
      if(this.deleteList.length > 0 && this.deleteList){
        this.centerDialog = true
      }else{
        this.$message.error('请选择要删除的助教')
      }
    },
    confirm(){
     let id= JSON.stringify(this.deleteList)
      let params = {
        assistant_id:id
      }
      this.$api.user.deleteAssistant(params)
        .then(res=>{
          if(res.code === 0){
            this.centerDialog = false
            this.onSubmit()
            this.$message.success('删除成功！')
          }
        }) 
    },
    cancel(){
      this.centerDialog = false
    },
    currentClick(val){
      let params = {
          realname:this.formInline.realname,
          phone:this.formInline.phone,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    nextClick(val){
      let params = {
          realname:this.formInline.realname,
          phone:this.formInline.phone,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    prevClick(val){
      let params = {
          realname:this.formInline.realname,
          phone:this.formInline.phone,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/content.scss';
  .cover_map{
    max-width:200px;
    height:75px;
  }
</style>